<template>
  <div class="task-result-container">
    <template>
      <TableHeadIcons :onRefresh="handleSearch" :size.sync="tableDensity" :columns="columns" />
      <a-table
        :size="tableDensity"
        :loading="loading"
        :pagination="pagination"
        @change="handleTableChange"
        rowKey="rowKey"
        :columns="showColumns"
        :data-source="tableData"
        :scroll="{ x: '100%', scrollToFirstRowOnChange: true }"
      >
        <span slot="status" slot-scope="_, record">
          <a-badge v-if="record.status == 0" color="red" text="失败"> </a-badge>
          <a-badge v-else-if="record.status == 1" color="green" text="成功"></a-badge>
        </span>
        <span slot="tableTitle" slot-scope="text">
          {{ text || '---' }}
        </span>
        <span slot="index" slot-scope="text, record, index">{{ index + 1 }}</span>
        <span slot="action" slot-scope="_, record">
          <router-link
            v-if="spiderClassType === 'news'"
            target="_blank"
            :to="{ name: 'news-detail-view', params: { rowKey: record.rowKey } }"
          >
            <a-button type="link">详情 </a-button>
          </router-link>

          <a-button v-else type="link" @click="showDetail(record)">详情 </a-button>
        </span>
      </a-table>
      <a-modal v-model="isShowDetail" title="详情" :footer="null" :width="700">
        <jsonView :data="detail" />
      </a-modal>
    </template>
    <!-- <template v-else>
      <SelfMediaInfo
        v-for="item in tableData"
        :key="item.rowKey"
        :mediaData="parseFailedWebResultMap[item.rowKey]"
      />
    </template> -->
  </div>
</template>

<script>
import { querySpiderResultsApi } from '@/api/Dispatch/TaskManage'
import jsonView from 'vue-json-views'
import TableHeadIcons from '@/components/TableHeadIcons'
import tableSettingToStoreMixin from '@/mixin/tableSettingToStroe'
import SelfMediaInfo from './SelfMediaInfo'
export default {
  components: { jsonView, TableHeadIcons, SelfMediaInfo },
  mixins: [tableSettingToStoreMixin()],
  data() {
    return {
      tableData: [],
      columns: [
        {
          width: 80,
          title: '序号',
          align: 'center',
          show: true,
          slots: { title: 'indexTitle' },
          scopedSlots: { customRender: 'index' }
        },
        {
          title: '地址',
          dataIndex: 'url',
          show: true,
          scopedSlots: { customRender: 'url' }
        },
        {
          title: '标题',
          dataIndex: 'title',
          show: true,
          scopedSlots: { customRender: 'tableTitle' }
        },
        {
          title: '任务ID',
          dataIndex: 'taskId',
          show: true,
          scopedSlots: { customRender: 'taskId' }
        },
        {
          title: '站点Id',
          dataIndex: 'spiderId',
          show: true,
          scopedSlots: { customRender: 'spiderId' }
        },
        {
          title: '状态',
          dataIndex: 'status',
          show: true,
          scopedSlots: { customRender: 'status' }
        },
        {
          title: '操作',
          key: 'action',
          show: true,
          scopedSlots: { customRender: 'action' },
          width: 110,
          align: 'center'
        }
      ],
      loading: false,
      pagination: {
        current: 1,
        pageSize: 10,
        showTotal: (total) => `共 ${total} 条`,
        showSizeChanger: true,
        showQuickJumper: true,
        total: 0,
        size: 'default'
      },
      tableDensity: 'middle',
      isShowColFilterOverlay: false,
      isShowDetail: false,
      detail: {},
      spiderClassType: '',
      parseFailedWebResultMap: {}
    }
  },
  computed: {
    showColumns() {
      return this.columns.filter((item) => item.show)
    }
  },
  created() {
    let { spiderClassType } = this.$route.query
    this.spiderClassType = spiderClassType
    this.handleSearch()
  },
  methods: {
    handleSearch() {
      let { taskId } = this.$route.query
      if (taskId) {
        this.querySpiderResults(taskId)
      }
    },

    onTableDensityChange(density) {
      this.tableDensity = density
    },

    handleTableChange(pagination) {
      this.pagination = pagination
      this.handleSearch()
    },

    async querySpiderResults(taskId) {
      let query = {
        pn: this.pagination.current,
        pageSize: this.pagination.pageSize,
        taskId
      }
      this.loading = true
      let res = await querySpiderResultsApi(query)
      this.loading = false
      let { code, msg, extra, data } = res
      if (code == '200') {
        this.tableData = data
        this.pagination.total = extra.page.pageTotal || 0
        this.parseFailedWebResultMap = extra.parseFailedWebResultMap || {}
      } else {
        this.$message.error(msg)
      }
    },

    showDetail(record) {
      this.detail = record
      this.isShowDetail = true
    }
  }
}
</script>
